module.exports = __webpack_public_path__ + "img/ic24Date.2add4709.svg";